export const COMPANY = `
query company(
    $id: Int! 
  ){
  company(
      id: $id
  )
  {
      __typename
      ... on Company{
          id
          name
          description
      }
      ... on ResultError{
          status_code
          message
      }
  }
  }
`;

export const COMPANIES = `
query companies(
    $searchText: String,
    $filter:  FilterCompanyInput,
    $orderBy:  CompanyOrderInput,
    $skip: Int,
    $take: Int
){
companies(
    searchText: $searchText
    filter: $filter
    orderBy: $orderBy
    skip: $skip
    take: $take
)
{
    __typename
    ... on Company{
          id
        name
        description
    }
    ... on ResultError{
        status_code
        message
    }
}
}

`;
